import { type FC, useContext } from "react";
import { useDrop } from "react-dnd";
import { DragDropEditorContext, type DragDropItem, isDragDropNew } from "./DragDropTypes";

interface Props {
    id: string;
}

export const DragDropContainerEmpty: FC<Props> = ({ id }) => {
    const { manager, accept, onCreate } = useContext(DragDropEditorContext);

    const [{ isOver }, drop ] = useDrop<DragDropItem, void, { isOver: boolean; }>(() => ({
        accept,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
        drop: (item, monitor) => {
            if(monitor.isOver()) {
                let component: string | null;

                if(isDragDropNew(item)) {
                    component = manager.registerComponent(onCreate(item.type));
                } else {
                    component = manager.detachComponent(
                        item.container,
                        item.index
                    );
                }

                if(!component) {
                    return;
                }

                manager.attachComponent(id, component, 0);
            }
        },
    }), [ accept, onCreate ]);

    return (
        <div
            ref={el => {
                drop(el);
            }}
            className={
                "flex justify-center items-center border-2 border-dashed border-gray-300 text-lg min-h-full py-8 " +
                "text-center overflow-hidden " + (isOver ? "opacity-100" : "opacity-50")
            }
        >
            Drop Component here
        </div>
    );
};
